import { IWidgetVisibility, WidgetPlaceType, IFontData, SelfPosition, IInteractiveElementColorData, ILinkData } from "./index";
import { IAnimatedWidget } from "./widget-style-data";

export interface IBreadcrumbsWidgetData extends IWidgetVisibility {
    readonly type: "BreadcrumbsWidget",
    placeType: WidgetPlaceType;
    id?: string | null;
    style: IAnimatedWidget;
    breadcrumbsStyle?: IBreadcrumbsStyleData | null;
    link?: IBreadcrumbLinkData | null;
    layoutType?: BreadcrumbsLayoutType | null;
    includeSeparator?: boolean | null;
}

export interface IBreadcrumbLinkData {
    id: string;
    text: string;
    value: ILinkData;
    isActive?: boolean;
    parentLink?: IBreadcrumbLinkData | null
}

export interface IBreadcrumbsStyleData {
    spaceBetweenItems?: number | null;
    alignment?: SelfPosition | null;
    font?: IFontData | null;
    regularLinkColorStyleData?: IInteractiveElementColorData | null;
    currentPageLinkColor?: string | null;
    iconColor?: string | null;
}

export type BreadcrumbsLayoutType = "leftToRight" | "rightToLeft";

export abstract class BreadcrumbsWidgetData {

    public static get defaultData(): IBreadcrumbsWidgetData {
        return {
            type: "BreadcrumbsWidget",
            placeType: "Section",
            link: null,
            breadcrumbsStyle: this.defaultBreadcrumbsStyle,
            includeSeparator: true,
            visibility: {
                desktop: true,
                tablet: true,
                mobile: true
            },
            layoutType: "leftToRight",
            style: {
                animation: {
                    animationSource: "site-design",
                    animationData: {
                        name: "none",
                        duration: 1
                    }
                }
            }
        };
    }

    public static get defaultStyle(): IAnimatedWidget {
        return {
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            }
        };
    }

    public static get defaultBreadcrumbsStyle(): IBreadcrumbsStyleData {
        return {
            spaceBetweenItems: 0,
            alignment: "start",
            font: {
                weight: "",
                family: "",
                size: "",
                lineHeight: ""
            },
            regularLinkColorStyleData: {
                colorDefault: "#70757D",
                colorHovered: "#DBDBDB"
            },
            currentPageLinkColor: "#202020",
            iconColor: "#70757D"
        };
    }

}